module.exports = __webpack_public_path__ + "static/english_circle_2-d09cb60a2b22e344a4d5db0eedef6ab4.svg";